export default __webpack_public_path__ + "static/media/castillito-thumb.ecaa1d18.png";